import {createSelector} from "@reduxjs/toolkit";
import BllinkTime from "../../common/utils/time";

export function getChargeDate(chargeDateMin, chargeDateMax, chargeDay, onGoingPaymentsLength) {
    const max = new Date(chargeDateMax);
    const min = new Date(chargeDateMin);
    const today = new Date();
    let storedChargeDate = BllinkTime.getTimeZoneOffset(new Date(max.getFullYear(), max.getMonth(), chargeDay));
    if (storedChargeDate.getMonth() === today.getMonth() && storedChargeDate.getFullYear() === today.getFullYear()) {
        storedChargeDate = today;
    }
    if (onGoingPaymentsLength.length > 0 && (storedChargeDate > max || storedChargeDate < min)) {
        const day = chargeDay <= max.getDate() && chargeDay >= min.getDate() ? chargeDay : min.getDate();
        const calculated = new Date(min.getFullYear(), min.getMonth(), day);
        return calculated.toJSON();
    }
    return storedChargeDate.toJSON();
}

export function getChargeDateMax(payments, assignedToNextMonth) {
    if (payments.length === 0) {
        return new Date().toJSON();
    }
    const firstOngoing = payments.reduce((prev, next) => (prev.year > next.year && prev.month > next.month) ? next : prev);
    let endDate = BllinkTime.getTimeZoneOffset(new Date(Number(firstOngoing.year), Number(firstOngoing.month), 0));
    if (assignedToNextMonth) {
        // https://app.asana.com/0/1201421792207582/1201547769585958
        // "consider assigned to next month - change in the datepicker logic "
        const monthBefore = BllinkTime.getPreviousMonth({
            month: Number(firstOngoing.month),
            year: Number(firstOngoing.year),
            day: 1
        });
        endDate = BllinkTime.getTimeZoneOffset(new Date(monthBefore.year, monthBefore.month, 0));
    }
    return endDate.toJSON();
}

export const chargeDateMaxSelector = createSelector(
    [state => state.onGoingSelectedPayments, state => state.assignedToNextMonth],
    getChargeDateMax,
);


export const chargeDateMinSelector = createSelector(
    [chargeDateMaxSelector, state => state.onGoingSelectedPayments],
    (chargeDateMax, onGoingPayments) => {

        // NOTE: Use should be allowed to pay from the current day even the selected month is in future
        //       see https://bllink.atlassian.net/browse/SSB-1091
        const today = new Date();
        return today.toJSON();

        // if (onGoingPayments.length === 0) {
        //     return new Date().toJSON();
        // }
        // const max = new Date(chargeDateMax);
        // const startDate = BllinkTime.getTimeZoneOffset(new Date(max.getFullYear(), max.getMonth(), 1));
        // const today = new Date();
        // if (startDate.getMonth() === today.getMonth() && startDate.getFullYear() === today.getFullYear()) {
        //     return today.toJSON();
        // }
        // return startDate.toJSON();
    },
);

export const chargeDateSelector = createSelector(
    [chargeDateMinSelector, chargeDateMaxSelector, state => state.chargeDay, state => state.onGoingSelectedPayments.length],
    getChargeDate,
);

export const getIfAnyPaymentsSelected = createSelector(
    [state => state.tenant.onGoingSelectedPayments, state => state.tenant.debtSelectedPayments, state => state.tenant.oneTimeSelectedPayments],
    (onGoingSelectedPayments, debtSelectedPayments, oneTimeSelectedPayments) => {
        return !!onGoingSelectedPayments?.length || !!debtSelectedPayments?.length || !!oneTimeSelectedPayments?.length;
    },
);


